export default __webpack_public_path__ + "static/media/CarDetailingProtection.95bb08f5.webp";